import { Stack } from "@mui/material";
import { DropzoneSingle } from "components/Dropzone";
import { SelectedFileBanner } from "components/SelectedFileBanner";
import { useTranslation } from "react-i18next";

import { EpcBackButton } from "./EpcBackButton";

type EpcUploadPhaseProps = {
  acceptedExtensions: string[];
  extractionError: null | string;
  onBack: () => void;
  onFileChange: (file: File | null) => void;
  selectedFile: File | null;
};

export const EpcUploadPhase = ({
  acceptedExtensions,
  extractionError,
  onBack,
  onFileChange,
  selectedFile,
}: EpcUploadPhaseProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="w-full flex-col items-stretch gap-4">
      <Stack className="w-full gap-2">
        <EpcBackButton onBack={onBack} />
        <h2 className="font-ds-headline-lg">{t("AddBuilding.epcModal.uploadScreenTitle")}</h2>
      </Stack>
      <p className="text-lds-foreground-muted font-ds-body-regular-md">
        {selectedFile ? t("general.fileSelected") : t("AddBuilding.epcModal.uploadScreenSubtitle")}
      </p>
      {selectedFile ? (
        <SelectedFileBanner className="text-left" fileName={selectedFile.name} onRemove={() => onFileChange(null)} />
      ) : (
        <DropzoneSingle
          acceptedFormats={acceptedExtensions}
          className="min-h-[12rem] w-full py-10"
          handleFileChange={onFileChange}
          hasIcon
        />
      )}
      {extractionError && (
        <p className="font-ds-body-regular-sm text-left text-lds-purpose-status-negative-subtle">{extractionError}</p>
      )}
      <p className="text-left text-lds-foreground-muted font-ds-body-regular-xs">
        {t("AddBuilding.epcModal.acceptedFormats")} {acceptedExtensions.join(", ")}
      </p>
    </Stack>
  );
};
